import { fetchFavoriteEntities } from '../../actions/favoriteEntities';
import { removeFolder, selectFolder } from '../../actions/folders/actions';
import { notify } from '../../actions/notifications';
import {
  fetchDeleteFolders,
  IDeleteFoldersRequest,
  TDeleteFoldersResponse,
} from '../../repositories/favorites/v1/delete-folders';
import { ENotificationStyle } from '../../types/notifications';
import { TThunkAction } from '../../types/redux';

export const deleteFolder =
  (id: number): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { httpApi, logger }) => {
    const parameters: IDeleteFoldersRequest = {
      ids: [id],
    };

    const showError = () => dispatch(notify('Не удалось удалить подборку', ENotificationStyle.Error));

    try {
      dispatch(selectFolder({ folder: null }));

      const { statusCode, response }: TDeleteFoldersResponse = await fetchDeleteFolders({ httpApi, parameters });

      if (statusCode === 200) {
        dispatch(fetchFavoriteEntities({ offset: 0 }));
        dispatch(removeFolder({ id }));
      }

      if (statusCode === 400) {
        showError();
        logger.warning(response.message || 'Fail to remove favorites folder (400 status code)');
      }
    } catch (e) {
      showError();
      logger.error(e, {
        description: 'Fail to remove favorites folder',
      });
    }
  };
